// extracted by mini-css-extract-plugin
export default {"textStyle":"DisplayData_textStyle__sDVHw","buttonColor":"DisplayData_buttonColor__UUvAb","titleStyle":"DisplayData_titleStyle__jF-Xc"};